<template>
  <el-row>
    <el-col :span="12">
      <BaseTableDetail
          class="quantity-table"
          :table-set-list="tableSetList1"
          :display-item="quantity"
          validate-scope="orderItem" />
    </el-col>
    <el-col :span="12">
      <BaseTableDetail
          class="quantity-table"
          :table-set-list="tableSetList2"
          :display-item="quantity"
          validate-scope="orderItem" />
    </el-col>
  </el-row>
</template>

<style scoped>
.quantity-table ::v-deep table tr th,
.quantity-table ::v-deep table tr td {
  padding: 5px 15px;
  font-size: 14px;
  text-align: left;
  vertical-align: top;
}
.quantity-table ::v-deep table tr th {
  padding-left: 15px;
  padding-right: 10px;
}

/* TODO ccs-ui.css がきいてしまうので暫定対応。いずれ削除したい */
.quantity-table ::v-deep table tr,
.quantity-table ::v-deep table tr:hover > td {
  background-color: initial;
}
.quantity-table ::v-deep table th {
  border-bottom: initial;
  width: 140px;
}
</style>

<script>
import _ from 'lodash'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import * as define from '@/define'

const TYPE = {
  orderItem: {
    tableSetList1: [
      { label: '初回',
        properties: [ {
          path: 'ordered', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.ORDERED_QTY
        } ] },
      { label: '未引当',
        properties: [ {
          path: 'unallocated', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.UNALLOCATED_QTY
        } ] },
      { label: '処理待ち',
        properties: [ {
          path: 'pending', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.PENDING_QTY
        } ] },
      { label: '指図待ち',
        properties: [ {
          path: 'preExport', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.PRE_EXPORT_QTY
        } ] },
      { label: '再送指図待ち',
        properties: [ {
          path: 'preReExport', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.PRE_RE_EXPORT_QTY
        } ] },
      { label: '指図前キャンセル',
        properties: [ {
          path: 'canceled', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.CANCELED_QTY
        } ] },
      { label: '指図済み',
        properties: [ {
          path: 'exported', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.EXPORTED_QTY
        } ] },
      { label: '出荷完了',
        properties: [ {
          path: 'shipped', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.SHIPPED_QTY
        } ] },
      { label: '出荷キャンセル',
        properties: [ {
          path: 'unshipped', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.UNSHIPPED_QTY
        } ] },
      { label: '出荷前キャンセル',
        properties: [ {
          path: 'inshipCanceled', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.INSHIP_CANCELED_QTY
        } ] },
      { label: '振替',
        properties: [ {
          path: 'transfer', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.TRANSFER_QTY
        } ] }
    ],
    tableSetList2: [
      { label: '返品',
        properties: [ {
          path: 'receiveShipped', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.RECEIVE_SHIPPED_QTY
        } ] },
      { label: '処理済返品',
        properties: [ {
          path: 'receiveFixed', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.RECEIVE_FIXED_QTY
        } ] },
      { label: '交換出荷(指図待ち)',
        properties: [ {
          path: 'exOut', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.EX_OUT_QTY
        } ] },
      { label: '交換出荷(指図済み)',
        properties: [ {
          path: 'exOutExported', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.EX_OUT_EXPORTED_QTY
        } ] },
      { label: '交換出荷(実績)',
        properties: [ {
          path: 'exOutShipped', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.EX_OUT_SHIPPED_QTY
        } ] },
      { label: '交換出荷キャンセル',
        properties: [ {
          path: 'exOutUnshipped', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.EX_OUT_UNSHIPPED_QTY
        } ] },
      { label: '処理済交換出荷',
        properties: [ {
          path: 'exOutFixed', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.EX_OUT_FIXED_QTY
        } ] },
      { label: '交換返品',
        properties: [ {
          path: 'exIn', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.EX_IN_QTY
        } ] },
      { label: '交換返品(実績)',
        properties: [ {
          path: 'exInShipped', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.EX_IN_SHIPPED_QTY
        } ] },
      { label: '処理済交換返品',
        properties: [ {
          path: 'exInFixed', type: 'Number',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QuantityDetail.EX_IN_FIXED_QTY
        } ] }
    ]
  },
  exchange: {
    tableSetList1: [
      { label: '指図待ち', properties: [ { path: 'preExportQty', type: 'Number' } ] },
      { label: '指図済', properties: [ { path: 'exportedQty', type: 'Number' } ] },
      { label: '出荷完了', properties: [ { path: 'shippedQty', type: 'Number' } ] }
    ],
    tableSetList2: [
      { label: '出荷キャンセル', properties: [ { path: 'unshippedQty', type: 'Number' } ] },
      { label: '消込済み', properties: [ { path: 'completedQty', type: 'Number' } ] },
      { label: 'キャンセル', properties: [ { path: 'inshipCanceledQty', type: 'Number' } ] }
    ]
  }
}

export default {
  name: 'QuantityDetail',
  components: {
    BaseTableDetail
  },
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    quantity: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    define: () => define,
    tableSetList1 () {
      return _.get(TYPE, `${this.type}.tableSetList1`)
    },
    tableSetList2 () {
      return _.get(TYPE, `${this.type}.tableSetList2`)
    }
  }
}
</script>
